module.exports = __webpack_public_path__ + "img/Menu1.a680a134.svg";